import {Injectable, inject} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {mergeMap} from 'rxjs';
import {ReportService} from '../../services';
import * as actions from './report.actions';

@State<void>({name: 'report'})
@Injectable({providedIn: 'root'})
export class ReportState {
    reportService = inject(ReportService);

    @Action(actions.FtpReport)
    ftpReport({dispatch}: StateContext<void>, {data, center}: actions.FtpReport) {
        return this.reportService
            .ftp(data, center)
            .pipe(mergeMap(data => dispatch(new actions.FtpReportReponse(data))));
    }

    @Action(actions.MbfReport)
    mbfReport({dispatch}: StateContext<void>, {data, center}: actions.MbfReport) {
        return this.reportService
            .mbf(data, center)
            .pipe(mergeMap(data => dispatch(new actions.MbfReportReponse(data))));
    }

    @Action(actions.DrpReport)
    drpReport({dispatch}: StateContext<void>, {data, center}: actions.DrpReport) {
        return this.reportService
            .drp(data, center)
            .pipe(mergeMap(data => dispatch(new actions.DrpReportResponse(data))));
    }

    @Action(actions.TcrReport)
    tcrReport({dispatch}: StateContext<void>, {data, center}: actions.TcrReport) {
        return this.reportService
            .tcr(data, center)
            .pipe(mergeMap(data => dispatch(new actions.TcrReportReponse(data))));
    }

    @Action(actions.RemapParticipantReport)
    remapParticipantReport({dispatch}: StateContext<void>, {data, center}: actions.RemapParticipantReport) {
        return this.reportService
            .remapParticipant(data, center)
            .pipe(mergeMap(data => dispatch(new actions.RemapParticipantReportResponse(data))));
    }

    @Action(actions.RemapCaseReport)
    remapCaseReport({dispatch}: StateContext<void>, {data, center}: actions.RemapCaseReport) {
        return this.reportService
            .remapCase(data, center)
            .pipe(mergeMap(data => dispatch(new actions.RemapCaseReportResponse(data))));
    }

    @Action(actions.RemapInfoSessionReport)
    remapSessionReport({dispatch}: StateContext<void>, {data, center}: actions.RemapInfoSessionReport) {
        return this.reportService
            .remapInfoSession(data, center)
            .pipe(mergeMap(data => dispatch(new actions.RemapInfoSessionReportResponse(data))));
    }
}
